export interface ISapList {
	id: string;
	sap_code: string;
	billing_concept: string;
	tipo_cuota?: string;
	status: string;
	created_at: string;
	products: any[];
}

export interface ISapResource {
	id?: string;
	sap_code?: string;
	created_at?: string;
	status?: string;
	billing_concept?: string;
	tipo_cuota?: string;
	domain?: string;
	contract?: ISapContract;
}

export interface ISapContract {
	id?: string;
	name?: string;
	products?: ISapProduct[];
}

export interface ISapProduct {
	id?: string;
	name?: string;
	type?: string;
	is_subproduct?: boolean;
	characteristics?: ISapProductCharacteristic[];
	associated_characteristics?: IProductCharacteristic[];
}

export interface IContract {
	type: string; // No llega es el tipo seleccionado al principio
	id: string;
	name: string;
	bundleProductOffering: IProductOffering[];
}

export interface IProductOffering {
	id: string;
	type: string;
	name: string;
	characteristics: IProductCharacteristic[];
}

export interface ISapProductCharacteristic {
	name: string;
	comparator: string;
	value: string;
}

export interface ISapListResponse {
	info: {
		data: ISapList[];
		limit: number;
		page: number;
		sort_column: string;
		sort_order: 'ASC' | 'DESC';
		total: number;
		total_absolut: number;
	};
}

export interface ISapListPayload {
	domain?: string;
	status?: string;
	search?: string;
	page?: number;
	limit?: number;
	sort_column?: string;
	sort_order?: string;
}

export interface IContractListResponse {
	info: IContract[];
}

export interface IContractListPayload {
	domain?: string;
	contract?: ISapContract;
}

export interface ISapPayload {
	sap_code?: string;
	billing_concept?: string;
	tipo_cuota?: string;
	domain?: string;
	contract?: {
		id?: string;
		products?: {
			id?: string;
			is_subproduct?: boolean;
			name?: string;
			type?: string;
			characteristics?: {
				id?: string;
				comparator?: string;
				value?: string;
			}[];
		}[];
	};
}

export interface IProductCharacteristic {
	name: string;
	comparators: string[];
	values: string[];
}

export enum SapContractType {
	FIBER = 'fiber',
	BUNDLE = 'bundle',
	MOBILE = 'mobile',
	OTHER_SERVICES = 'other_services',
}

export interface ISapResponse {
	info: ISapResource;
}
